(function ($) {
  
  var promoOffersTrigger = $("#shopify-section-header .aph_bar_btn_holder a"),
      promoOffersWrapper = $(".js-promoOffers"),
      body = $("body");

  // Wait notification bar to load
    waitForElm('#shopify-section-header .aph_bar_btn_holder a').then((elm) => {
      
      var count = promoOffersWrapper.find('.promoOffers__inner > .promoOffers__content').children().length; 

       if(elm.textContent == 'View Offers') {
         $( "<span class='count'>"+ count +"</span>" ).appendTo(elm); 
       }
    });

  // Trigger button
  body.on('click', "#shopify-section-header .aph_bar_btn_holder a", function(e) {
      if (e.preventDefault(), !promoOffersWrapper)
              return !1;
    toggleAsideOffers();
    
  });

  // Close button
  body.on('click', '.promoOffers__close, .promoOffers__bg', function() {
    toggleAsideOffers();
  });

  function toggleAsideOffers() {
      promoOffersWrapper.toggleClass('active', function() {
      if ( $( promoOffersWrapper ).hasClass("active" ) ) {
        body.removeClass("overflow--hidden");
        // promoOffersWrapper.removeClass('active');
      } else {
        body.addClass("overflow--hidden");
        // promoOffersWrapper.addClass('active');
      }
    });
  }

  function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
  }
  
})(jQuery);